import { Box, Fade, Popper, PopperProps } from "@mui/material";
import { useCallback } from "react";

import { useOnboardingContextOptional } from "@/common/contexts/onboarding";

import { OnboardingPopperContent } from "./OnboardingPopperContent";

export const OnboardingPopperMode = {
  Collapsed: "Collapsed",
  Expanded: "Expanded",
} as const;
export type OnboardingPopperMode = (typeof OnboardingPopperMode)[keyof typeof OnboardingPopperMode];

interface Props extends Omit<PopperProps, "open"> {
  onClose?: () => void;
}

export function OnboardingPopper({ sx, onClose, ...otherProps }: Props) {
  const onboardingContext = useOnboardingContextOptional();

  const handleClose = useCallback(() => {
    onClose ? onClose() : onboardingContext?.popper.close();
  }, [onboardingContext, onClose]);

  if (!onboardingContext?.isEnabled) {
    return null;
  }

  return (
    <Popper
      // anchorEl={anchorRef.current}
      open={onboardingContext.popper.isOpen}
      transition
      placement='bottom'
      sx={{ zIndex: (th) => th.zIndex.modal, ...sx }}
      {...otherProps}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Box>
            <OnboardingPopperContent onClose={handleClose} />
          </Box>
        </Fade>
      )}
    </Popper>
  );
}
